/*
 * Layer ordering in Mapbox is dependent on when the layer is added
 * to the map. Layers are loaded to the map in a stack, last added is rendered on top.
 * In our case, we load some data asynchronously so by the default behavior
 * those layers would get loaded at the end, and therefore at the top.
 * This is not always the desired behavior.
 * (Example: We fetch municipality borders asynchronously so they might render
 * on top of home markers if they take longer to fetch)
 *
 * This module corrects this problem by using the "beforeId" property of layers,
 * which tells a layer to go before another one (earlier in the stack).
 *
 * We render some empty reference layers onto the map and give them z-[index] names. These
 * layers have a deterministic order in the stack. Then when we render our asynchronously
 * loaded layers, we tell them (using beforeId) which z-layer to go before (under).
 *
 */

import { Source, Layer } from "react-map-gl";
import { range } from "~/lib/utils";

export const NUM_Z_LAYERS = 10;

const layerOrderIndices = range(0, NUM_Z_LAYERS);  // [0..9]

export function ZIndexLayers() {
  return (
    <Source
      id="empty"
      type="geojson"
      data={{ type: "FeatureCollection", features: [] }}
    >
      <>
        {layerOrderIndices.map(i => <Layer
          key={`z-${i}`}
          id={`z-${i}`}
          type="symbol"
          source="empty"
        />)}
      </>
    </Source>
  );
}
